import React from 'react';
import { CatalogTableContainer } from 'containers/product-catalog/CatalogTable';

export const CatalogIcelandSlice = ({ title, tagline, categories, showAll, items, isSlice }) => {
  const catgoryList = categories ? categories.split(',').map((s) => s.trim()) : [];

  return (
    <CatalogTableContainer
      title={title}
      tagline={tagline}
      catalog={items.products}
      verification={items.verification}
      options={catgoryList}
      showAll={showAll}
      isSlice={isSlice}
    />
  );
};

export default CatalogIcelandSlice;
